import { render } from "./APTeam.vue?vue&type=template&id=70866947&scoped=true"
import script from "./APTeam.vue?vue&type=script&lang=js"
export * from "./APTeam.vue?vue&type=script&lang=js"

import "./APTeam.vue?vue&type=style&index=0&id=70866947&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70866947"]])

export default __exports__